module.exports = __webpack_public_path__ + "static/img/93-1.57568fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/93-1.jpg
// module id = UIf1
// module chunks = 0